<template>
  <v-layout row>
    <v-text-field
      outline
      hide-details
      class="ma-1 required"
      :label="$t('fields.name')"
      v-model="name"
      :rules="required">
    </v-text-field>
    <v-text-field
      outline
      hide-details
      v-model="lastName"
      class="ma-1"
      :label="$t('fields.last_name')">
    </v-text-field>
    <v-text-field
      outline
      hide-details
      v-model="identifier"
      class="ma-1 required"
      :label="$t('fields.identifier')"
      append-icon="mdi-barcode-scan"
      :rules="required">
    </v-text-field>
    <v-btn v-if="showButton" @click="removeGuest()" icon class="align-self-center"><v-icon>clear</v-icon></v-btn>
  </v-layout>
</template>
<script>
import ValidationRules from '@/mixins/ValidationRules'
import { mapState } from 'vuex'
export default {
  props: {
    index: Number,
    showButton: Boolean
  },
  mixins: [
    ValidationRules
  ],
  methods: {
    removeGuest () {
      this.$store.commit('main/removeGuest', this.index)
    }
  },
  computed: {
    ...mapState(['main']),
    name: {
      get () {
        return this.main.edited ? this.main.edited.guests[this.index].name : null
      },
      set (value) {
        this.$emit('change', { name: value })
      }
    },
    lastName: {
      get () {
        return this.main.edited ? this.main.edited.guests[this.index].lastName : null
      },
      set (value) {
        this.$emit('change', { lastName: value })
      }
    },
    identifier: {
      get () {
        return this.main.edited ? this.main.edited.guests[this.index].identifier : null
      },
      set (value) {
        this.$emit('change', { identifier: value })
      }
    }
  }
}
</script>
